export const transitions = {
    transitionSlow: '450ms',
    transitionNormal: '350ms',
    transitionFast: '250ms',
    transitionTypeDefault: 'ease-in-out',
};

export default transitions;
